// import { ApolloClient } from "apollo-client";
import { BrowserRouter as Router } from "react-router-dom";
// import { HttpLink, InMemoryCache } from "apollo-client-preset";
import { ApolloProvider } from "react-apollo";
import { Provider } from "react-redux";
import React from "react";
import ReactDOM from "react-dom";

import "semantic-ui-css/semantic.min.css";
import "antd/dist/antd.css";

import store from "./reducers";
import App from "./components/App/App";
import registerServiceWorker from "./registerServiceWorker";
import "../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import "./index.css";
import client from './config/apollo'

// const graphqlUrl = "https://data.visp.net/graphql";

// const client = new ApolloClient({
//   link: new HttpLink({ uri: graphqlUrl }),
//   cache: new InMemoryCache()
// });

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </ApolloProvider>,
  document.getElementById("root")
);
registerServiceWorker();
